export enum ICON_ENUM {
  BUILD = "build",
  LOCAL_GAS_STATION = "local_gas_station",
  RECEIPT_LONG = "receipt_long",
  DASHBOARD = "dashboard",
  ARCHIVE = "archive",
  DIRECTIONS_CAR = "directions_car",
  SEARCH = "search",
  ARROW_FORWARD = "arrow_forward",
  SUN = "light_mode",
  SNOW = "ac_unit",
  FEED = "feed",
  EDIT = "edit",
  USER = "person_outline",
  INFO = "info",
  MAIL_UNREAD = "mark_email_unread",
  MAIL_READ = "drafts",
  DONE = "done",
  CANCEL = 'cancel',
  REFRESH = 'refresh'
}
